// In the BP this should be empty. Enter your custom JS here

import FingerprintJS from '@fingerprintjs/fingerprintjs-pro'
import 'select2'

$('.js-select-2').select2()
$('#purchase_date_modal').modal('show')

const productForm = document.forms.length && document.forms[0].id == 'product-form' ? document.forms[0] : null

if (productForm) {
    /** @type HTMLSelectElement */
    const productDropdown = productForm.product_id
    /** @type HTMLSelectElement */
    const retailerDropdown = productForm.retailer_id

    const req = new XMLHttpRequest()

    function showError() {
        alert('Unexpected error occurred, please try again later.')
    }

    req.addEventListener('load', function () {
        if (this.status != 200) {
            showError()
            return
        }

        const retailers = JSON.parse(this.responseText)

        // Remove all options except "Please Select"
        while (retailerDropdown.options.length != 1) {
            retailerDropdown.options.remove(1)
        }

        for (const retailerId in retailers) {
            retailerDropdown.add(new Option(retailers[retailerId], retailerId))
        }
    })

    req.addEventListener('error', showError)

    /** @this HTMLSelectElement */
    function populateRetailers() {
        retailerDropdown.disabled = !this.validity.valid
        if (retailerDropdown.disabled) {
            return
        }

        req.open('GET', productForm.getAttribute('data-ajax-url').replace('product-id', this.value))
        req.send()
    }

    $(productDropdown).on('select2:select', populateRetailers)
}

/** @type HTMLSelectElement */
const returnReasonDropdown = document.getElementById('return_reason')

if (returnReasonDropdown) {
    if (!document.getElementById('purchased_at').value) {
        document.getElementById('purchased_at').value = document.getElementById('js-purchase-date').value
    }

    /** @type HTMLTextAreaElement */
    const returnReasonOther = document.getElementById('return_reason_other')
    returnReasonOther.required = true

    if (returnReasonOther.labels) returnReasonOther.labels[0].textContent += ' *'

    /** @this HTMLSelectElement */
    function toggleOtherReturnReason() {
        if (this.value.toLowerCase() == 'other') {
            returnReasonOther.disabled = false
        } else {
            returnReasonOther.disabled = true

            if (~this.value.toLowerCase().indexOf('faulty')) {
                $('#faulty_product_modal').modal('show')
            }
        }

        returnReasonOther.parentElement.parentElement.hidden = returnReasonOther.disabled
    }

    returnReasonDropdown.addEventListener('change', toggleOtherReturnReason)
    toggleOtherReturnReason.call(returnReasonDropdown)
}

FingerprintJS.load({ token: process.env.MIX_FINGERPRINT_KEY, region: 'eu' })
    .then(fp => fp.get())
    .then(result => navigator.sendBeacon(document.head.dataset.visitorUrl, result.visitorId));
